const STATS = [
  { num: "20+", title: "Years Processing Capability" },
  { num: "1,000+", title: "Customers Served" },
  { num: "30+", title: "Countries Served" },
  { num: "2", title: "Manufacturing Facilities" },
];

export default function Stats() {
  return (
    <div className="stats-band" data-testid="stats-band">
      <div className="wrap stats-grid">
        {STATS.map((s) => (
          <div className="stat-card" key={s.title} data-testid={`stat-${s.title.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="stat-num">{s.num}</div>
            <div className="stat-title">{s.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
